export var Paths;

(function (Paths) {
  Paths["List"] = "/me/notifications";
  Paths["GetUnreadStatus"] = "/me/notifications/unread_status";
  Paths["MarkAsRead"] = "/me/notifications/mark_as_read";
})(Paths || (Paths = {}));